module.exports = __webpack_public_path__ + "static/img/role-fr.d891ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/role-fr.png
// module id = wSbe
// module chunks = 1